import _ from 'lodash';
import { extendsModule, baseFormItem } from 'src/store/base';
import * as types from 'src/store/types';

export const INIT = {
  title_list: [
    {
      title: '',
    },
  ],
};

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'procedural-creative-title-list',
    title_list: _.cloneDeep(INIT.title_list),
  },
  getters: {
    formItemData(state) {
      return {
        title_list: state.title_list,
      };
    },
  },
  mutations: {
    [types.ADD_PCD_TITLE](state, data) {
      state.title_list.push({
        title: data,
      });
    },
    [types.ADD_SMART_TEXT_PCD_TITLE](state, data) {
      // 找一下第一条空文案序号
      const firstBlankTitleIndex = state.title_list.findIndex(item => item.title === '');
      // 是否有空文案
      const hasBlankTitle = firstBlankTitleIndex !== -1;
      const { title = '', smartTextInfo } = data;
      // 组装智能文案对象
      const smartTextItem = {
        title,
        smartTextInfo,
      };
      // 如果有空文案，替换空文案
      if (hasBlankTitle) {
        state.title_list.splice(firstBlankTitleIndex, 1, smartTextItem);
      } else {
        // 否则执行追加
        state.title_list.push(smartTextItem);
      }
    },
    [types.DELETE_PCD_TITLE](state, index) {
      state.title_list.splice(index, 1);
    },
    [types.UPDATE_PCD_TITLE](state, data) {
      const { index, value, extraAttr = {} } = data;
      const old = state.title_list[index];
      delete old.reject_reason; // 变动标题时删除拒审理由
      state.title_list.splice(index, 1, {
        ...old,
        title: value,
        ...extraAttr,
      });
    },
  },
  actions: {
    data2State({ commit }, formData) {
      const list = formData.title_list && formData.title_list.length
        ? formData.title_list
        : _.cloneDeep(INIT.title_list);
      commit('update', {
        title_list: list,
      });
    },
  },
});
